import { PushIlmoituksenTyyppi } from '../model/push-ilmoitus'

/** Collection-id myös collectionGroup-kyselylle (lähetyseräajo). */
export const PUSH_ILMOITUS_LAHETYSJONO_COLLECTION = 'push-ilmoitus-jono'

export class PushIlmoitusUriService {
  /** Lemonaidin Firestore. Dokumentin avain on ilmoituksen tyyppi — sama tyyppi niputtuu aina yhteen jonomerkintään. */
  annaPushIlmoitusLahetysjonoCollection(asiakasAvain: string) {
    return `tyojono_data/${asiakasAvain}/${PUSH_ILMOITUS_LAHETYSJONO_COLLECTION}`
  }

  /** Lemonaidin Firestore */
  annaPushIlmoitusLahetysjono(asiakasAvain: string, tyyppi: PushIlmoituksenTyyppi) {
    return `${this.annaPushIlmoitusLahetysjonoCollection(asiakasAvain)}/${tyyppi}`
  }

  /** Lemonaidin Firestore. Yksi dokumentti per lähetyskerta: mitä lähetettiin. */
  annaLahetyskerranUri(asiakasAvain: string, flushAvain: string) {
    return `customers/${asiakasAvain}/push-ilmoitukset/${flushAvain}`
  }
  /** Lemonaidin Firestore. Yksi dokumentti per käyttäjä per lähetyskerta: kenelle ja mille laitteille. */
  annaPushIlmoitusHistoriaUri(asiakasAvain: string, flushAvain: string, kayttajaAvain: string) {
    return `${this.annaLahetyskerranUri(asiakasAvain, flushAvain)}/push-ilmoitukset-historia/${kayttajaAvain}`
  }
  /** Lemonaidin Firestore */
  annaUserFirebaseInstallationsUri(asiakasAvain: string, kayttajaAvain: string) {
    return `customers/${asiakasAvain}/customers-users/${kayttajaAvain}/user-firebase-installations/${kayttajaAvain}`
  }
  /** Lemonaidin Firestore. Installaatioiden tokeniton kopio webille ja Lemonatorille. */
  annaKayttajanLaitteetUri(asiakasAvain: string, kayttajaAvain: string) {
    return `customers/${asiakasAvain}/customers-users/${kayttajaAvain}/kayttajan-laitteet/${kayttajaAvain}`
  }
}
